import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserHelper } from '../../../../helpers/user.helper';
import { ClubRoles } from '../../../../models/clubs/club-roles.model';
import { Club } from '../../../../models/clubs/club.model';
import { Member } from '../../../../models/clubs/member.model';

@Component({
    selector: 'app-list-item-user',
    templateUrl: './list-item-user.component.html',
    styleUrls: ['./list-item-user.component.scss'],
})
export class ListItemUserComponent implements OnInit {
    @Output()
    shouldUpdateMembers = new EventEmitter<{
        memberId: string;
        newRole: ClubRoles;
    }>();

    @Output()
    shouldRemoveMember = new EventEmitter<string>();
    @Input() member: Member;
    @Input() club: Club;
    @Input() currentUserRole: ClubRoles;
    @Input() isMemberEditable: boolean;
    @Input() canCurrentUserManageMember: boolean;
    @Input() truncateLimit: number;
    memberIsHovered: boolean;
    public truncateText: boolean;

    constructor(public readonly userHelper: UserHelper) {}

    ngOnInit(): void {
        this.truncateText = (this.truncateLimit ?? 0) > 0;
    }

    onUpdateMemberRole($event: any) {
        this.shouldUpdateMembers.emit($event);
    }
    onRemoveMember($event: any) {
        this.shouldRemoveMember.emit($event);
    }
}
